export default "__VITE_ASSET__9647bc9d__"